<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item class="endBtn" v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`维保列表_订单回收站`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" >
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repair',
      breadcrumb: [
        { name: "维保管理", path: `/fix/recycle` },
        { name: "订单回收站", path: `/fix/recycle` },
      ],
      baseParams: ['isdelete'],
      formInline: {
        isdelete: 1,
      },
      formCtrl: [
        {
          ...this.ctrls.license,
        },
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          label: "维保类型",
          keyName: "article",
          placeholder: "请选择维保类型",
          type: "select",
          options: [],
        },
        {
          label: "维修商",
          keyName: "maunit",
          placeholder: "请填写维修商",
          type: "text",
        },
        {
          label: "维保时间",
          keyName: "month",
          placeholder: "请选择",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 90 },
        { keyName: "driver", label: "司机" },
        { keyName: "fleet_name", label: "车队长" },
        { keyName: "article_name", label: "维保类型" },
        { keyName: "maunit", label: "维修商", minwidth: 150 },
        { keyName: "rstarttime", label: "维保时间", minwidth: 100 },
        { keyName: "money", label: "花费金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "add_name", label: "填写人" },
        { prop: "del_desc", label: "删除原因" },
        { prop: "del_name", label: "删除人" },
        { prop: "del_time", label: "删除时间" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/fix/recycledetail?mode=view&id=${id}`
            );
          },
        },
      ],
    };
  },
  methods: {
    getOptions() {
      let url = `${this.baseUrl}/getsearch`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ fleet, article }) => {
        this.formCtrl.map(v => {
          if (v.keyName === 'fleet') {
            this.setCtrlOption(v, fleet, 'nickname')
          } else if (v.keyName === 'article') {
            this.setCtrlOption(v, article)
          }
        })
        this.$forceUpdate()
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getOptions();
    this.getList()
  },
};
</script>

<style lang="less" scoped></style>
